export default [
    {
        path: 'policy',
        name: 'privacy-policy',
        component: () => import('@/views/policy/Index'),
        meta: {
            nextable: true
        }
    },
]